import React from 'react';
import notfound from '../../image/notFound/notfound.png'

const NotFound = () => {
    return (
        <div className=''>
            <img className='w-100' src='https://3kllhk1ibq34qk6sp3bhtox1-wpengine.netdna-ssl.com/wp-content/uploads/2017/12/dogstudio.gif' alt="" />
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default NotFound;